import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import getCSSSelector_1 from '../../../../../libraries/Images/getCSSSelector_1.png';
import getCSSSelector_2 from '../../../../../libraries/Images/getCSSSelector_2.png';
import getCSSSelector_3 from '../../../../../libraries/Images/getCSSSelector_3.png';
import getCSSSelector_4 from '../../../../../libraries/Images/getCSSSelector_4.png';

import makeYourFirstRobot_1 from '../../../../../libraries/Images/makeYourFirstRobot_1.png';
import makeYourFirstRobot_2 from '../../../../../libraries/Images/makeYourFirstRobot_2.png';
import makeYourFirstRobot_3 from '../../../../../libraries/Images/makeYourFirstRobot_3.gif';
import makeYourFirstRobot_4 from '../../../../../libraries/Images/makeYourFirstRobot_4.png';
import makeYourFirstRobot_5 from '../../../../../libraries/Images/makeYourFirstRobot_5.png';
import makeYourFirstRobot_6 from '../../../../../libraries/Images/makeYourFirstRobot_6.png';
import makeYourFirstRobot_7 from '../../../../../libraries/Images/makeYourFirstRobot_7.png';

import runYourRobot_1 from '../../../../../libraries/Images/runYourRobot_1.png';
import runYourRobot_2 from '../../../../../libraries/Images/runYourRobot_2.png';

import scheduleRobotRun_1 from '../../../../../libraries/Images/scheduleRobotRun_1.png';
import scheduleRobotRun_2 from '../../../../../libraries/Images/scheduleRobotRun_2.png';
import scheduleRobotRun_3 from '../../../../../libraries/Images/scheduleRobotRun_3.png';
import scheduleRobotRun_4 from '../../../../../libraries/Images/scheduleRobotRun_4.png';
import scheduleRobotRun_5 from '../../../../../libraries/Images/scheduleRobotRun_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="getcssselector">
                1. {translate('getcssselector')}
            </Typography>
            <p>CSS selectors are utilized to identify HTML elements on web pages.</p>
            <p> By utilizing CSS selectors, we can execute web page actions using RPA CLOUD.</p>
            <p> To begin, you must install the RPA CLOUD extension in Chrome. Please refer <Box component={Link} to='/control-center/documentation/gettingstarted/installation/#chrome-extension'>here</Box> for the installation instructions.</p>
            <p>The procedure:</p>
            <ol>
                <li>Open the page showing the element you want to get.</li>
                <p>For example, you open <a href="https://www.amazon.com/" target="_blank">https://www.amazon.com/</a>.</p>
                <Zoom>
                    <img src={getCSSSelector_1} width="75%" />
                </Zoom>
                <li>Right click on the element you want to get.</li>
                <p>The element you need to get the CSS selector is the [Search] field, then just move to the [Search bar] location and right click on it.</p>
                <Zoom>
                    <img src={getCSSSelector_2} width="75%" />
                </Zoom>
                <li>Click on the context menu [Copy CSS Selector].</li>
                <p>After clicking [Copy CSS Selector], the element will show a blue border. This blue border indicates that the CSS selector was successfully retrieved.</p>
                <Zoom>
                    <img src={getCSSSelector_3} width="75%" />
                </Zoom>
                <li>Paste the copied CSS Selector and confirm.</li>
                <p>Finally paste it into a text editor (Windows: [Ctrl]+[V] / Mac: [Command]+[V]). You will see that the CSS Selector has been successfully obtained.</p>
                <Zoom>
                    <img src={getCSSSelector_4} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="makeyourfirstrobot">
                2. {translate('makeyourfirstrobot')}
            </Typography>
            <p>For example, let's create a robot that searches for an iPhone item on the Amazon website.</p>
            <p>Procedure:</p>
            <ol>
                <li>First, click <a href="/control-center/workspace" target="_blank">here</a> to create the robot.</li>
                <li>Next, click the [Add new] button and fill in the following fields:</li>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_1} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Select a Project name. If you don't have a project, click the ➕ button (❶a) on the left to create one.</li>
                    <li>❷&nbsp;Enter the Robot name.</li>
                    <li>❸&nbsp;Select an Icon for the robot.</li>
                    <li>❹&nbsp;Choose the Background color for the robot.</li>
                    <li>❺&nbsp;Choose the Color for the robot's icon.</li>
                    <li>❻&nbsp;Select whether to "send" or "not send" an email when any error occurs.</li>
                    <li>❼&nbsp;Type the description for the robot.</li>
                    <p>Click the [OK] button to finish.</p>
                </ul>
                <li>After succesfully creating the robot, a card for the robot will appear (one card per robot).</li>
                <p>Click the wrench button to build the script for the robot.</p>
                <Zoom>
                    <img src={makeYourFirstRobot_2} width="75%" />
                </Zoom>
                <li>To build the action for [Open Browser] .</li>
                <p>Hold and drag the [Open Browser] action.</p>
                <Zoom>
                    <img src={makeYourFirstRobot_3} width="75%" />
                </Zoom>
                <p>Type the URL of the target website.</p>
                <p>Click the gear icon to open the options box, then type the link of the Amazon website in the [Url] field. Finally, click the [Save]button to save changes.</p>
                <Zoom>
                    <img src={makeYourFirstRobot_4} width="75%" />
                </Zoom>
                <li>To build the action of [Type Text].</li>
                <p>Type the text "iphone 13 pro max" in the search field on the Amazon website, follow these steps:</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_5} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Hold and drag the [Type Text] action.</li>
                    <li>❷&nbsp;Click the gear icon to open the options box.</li>
                    <li>❸&nbsp;Choose the target website where you want to input the text. If you have multiple websites open, each website corresponds to a specific output key.</li>
                    <li>❹&nbsp;Open the Amazon website in the browser and copy the CSS selector of the text input field on the Amazon website and paste it in here.</li>
                    <li>❺&nbsp;Type the desired texts, in this example, "iphone 13 pro max" in the text field.</li>
                    <p>Finally, click the [Save] button to save the action.</p>
                </ul>
                <li>To build the action of [Click].</li>
                <p>Click the search button on the Amazon website.</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_6} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Hold and drag the [Click] action.</li>
                    <li>❷&nbsp;Click the gear icon to open the options box.</li>
                    <li>❸&nbsp;Choose the target website where you want to click.  If you have multiple websites open, each website corresponds to a specific output key. </li>
                    <li>❹&nbsp;Open the Amazon website in the browser and copy the CSS selector of the position you want to click on the Amazon website and paste it in here.</li>
                    <p>Finally, click the [Save] button to save the action.</p>
                </ul>
                <li>To save the script of the robot.</li>
                <p> Click the [Save] button to save the robot's script. IF YOU DON'T click the Save button, your script will no be saved when you reload the page </p>
                <Zoom>
                    <img src={makeYourFirstRobot_7} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="runyourrobot">
                3. {translate('runyourrobot')}
            </Typography>
            <p>You can check whether your robot runs properly by following the procedure below.</p>
            <p>Procedure:</p>
            <ol>
                <li>Click the [Run] button to execute your robot.</li>
                <Zoom>
                    <img src={runYourRobot_1} width="75%" />
                </Zoom>
                <li>Check the result.</li>
                <p>With the actions executed on web browser, you can see the result containing images in case you turn on  [Take screenshot].</p>
                <Zoom>
                    <img src={runYourRobot_2} width="75%" />
                </Zoom>
                <p>To go back to the robot creation page, click ✖️ on the top right .</p>
            </ol>
            <Typography variant="h5" gutterBottom id="schedulerobotrun">
                4. {translate('schedulerobotrun')}
            </Typography>
            <p>You can set the schedule for your robot.</p>
            <p>Procedure:</p>
            <ol>
                <li>Click <a href="/control-center/schedule" target="_blank">here</a> to set the schedule for robot.</li>
                <li>Click the [Add new] button.</li>
                <p>Then, click the [Next] button</p>
                <Zoom>
                    <img src={scheduleRobotRun_1} width="75%" />
                </Zoom>
                <li>Set the timezone and click the [Next] button.</li>
                <Zoom>
                    <img src={scheduleRobotRun_2} width="75%" />
                </Zoom>
                <li>Confirm the schedule and click the [OK] button.</li>
                <Zoom>
                    <img src={scheduleRobotRun_3} width="75%" />
                </Zoom>
                <li>After setting the schedule, one record will be appeared  (one record coressponds one schedule).</li>
                <Zoom>
                    <img src={scheduleRobotRun_4} width="75%" />
                </Zoom>
                <p> To check the history of a schedule or delete it, check the target schedule and select your option.</p>
                <Zoom>
                    <img src={scheduleRobotRun_5} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(En);